import { typeEditStore, typeStoreFilters } from "./dStoresReducer";
import { typeRequestPagination } from "../system/constants";
import { apiClient } from "model/axiosConfig";

// Type
export type typeStoreRequestFilters = {
  filters: {
    name?: string | string[] | null;
    deleted?: boolean | null;
  };
  full?: boolean;
  pageFilter?: typeRequestPagination;

  sortFilter?: {
    direction: string;
    column: string;
  };
};

// Get store list
export const getStoreList = async (payload: {
  filters: typeStoreFilters;
  full?: boolean;
  paginationRequest?: typeRequestPagination;
}) => {
  const path = "/product/store/search";
  const config = {
    headers: {},
  };

  const data: typeStoreRequestFilters = {
    filters: {},
    full: payload.full !== undefined ? payload.full : true,
    sortFilter: {
      direction: "ASC",
      column: "name",
    },
    pageFilter: payload.paginationRequest,
  };

  if (payload.filters.name) data.filters.name! = [payload.filters.name];

  if (Object.keys(payload.filters).includes("deleted"))
    data.filters.deleted = payload.filters.deleted;

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    return error;
  }
};

// Get store list slim
export const getStoresListSlim = async () => {
  const path = "/product/store/slim";
  const config = {
    headers: {},
    sortFilter: {
      direction: "ASC",
      column: "name",
    },
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Edit store item
export const changeStoresItem = async (payload: {
  dataObject: typeEditStore;
}) => {
  const path = "/product/store";
  const config = {
    headers: {},
  };
  const data = payload.dataObject;

  try {
    return await apiClient.patch(path, data, config);
  } catch (error) {
    return error;
  }
};

// Get rest cash in store
export const getRestCashForAllPos = async () => {
  const path = "/product/encash/acc";
  const config = {
    headers: {},
  };
  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error;
  }
};

export const getStore = async (storeId: string) => {
  const path = `/product/store/${storeId}`;

  try {
    return await apiClient.get(path);
  } catch (error) {
    return error;
  }
};
